import type { ThemeSelection } from "@site-factory/theme";

/**
 * Theme selection for Template site
 * Change this to switch the entire site's theme
 */
export const themeSelection: ThemeSelection = "default";
